import { useContext } from 'react';
import { Field } from '../../../../layouts';
import { AR, ROType, ScriptFileType } from '../../../../types/enums';
import { formatDateWithTimeframe, formatShortDate, TimeframeType } from '../../../../utils/date-utils';
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';
import CallScriptComp from '../../call-script/component/CallScriptComp';

export default function RetailOrderCabinetDates(props: {
	showScheduledInstallDates?: boolean,
	showActualInstallDates?: boolean,
	showChangeOrderCallScript?: boolean
}) {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const isMeasureOrder = order.details.roTypeID === ROType.CabinetMeasureOrder;

	return (
		<>
			{
				isMeasureOrder ?
					<>
						<Field label={'Customer Contact Date'}>
							{formatShortDate(order.details.customerContactDate)}
						</Field>
						<Field label={'Ready to Measure Date'}>
							{formatShortDate(order.details.readyToMeasureOrTemplateDate)}
						</Field>
						<Field label={'Scheduled Measure Date'}>
							{formatDateWithTimeframe(order.details.measureDate, TimeframeType.Short)}
						</Field>
						<Field label={'Actual Measure Date'}>
							{formatShortDate(order.details.actualMeasureDate)}
						</Field>
					</>
					:
					<div className='field-label-70'>
						<Field label={'Estimated Cabinet Delivery Date'}>
							{formatShortDate(order.details.estimatedCabinetDeliveryDate)}
						</Field>
						<Field label={'Scheduled Install Start Date'} visible={!!props.showScheduledInstallDates}>
							{formatShortDate(order.details.scheduledInstallStartDate)}
						</Field>
						<Field label={'Scheduled Install Completion Date'} visible={!!props.showScheduledInstallDates}>
							{formatShortDate(order.details.scheduledInstallCompletionDate)}
						</Field>
						<Field label={'Cabinet PO Received Date'}>
							{formatShortDate(order.details.cabinetPOReceivedDate)}
						</Field>
						<Field label={'Actual Install Start Date'} visible={!!props.showActualInstallDates}>
							{formatShortDate(order.details.actualInstallStartDate)}
						</Field>
						<Field label={'Lower Cabinets Plumb & Level Date'} visible={!!props.showActualInstallDates}>
							{formatShortDate(order.details.lowerCabinetsPlumbLevelDate)}
						</Field>						
						<Field label={'Actual Install Completion Date'} visible={!!props.showActualInstallDates}>
							{formatShortDate(order.details.actualInstallCompletionDate)}
						</Field>
					</div>
			}

			{props.showChangeOrderCallScript && (order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) || order.details.resolvedARs.includes(AR.DealerToConfirmChangeOrder)) &&
				<CallScriptComp
					fileType={ScriptFileType.CabinetInstallerChangeOrder}
					retailOrderID={order.details.retailOrderID}
					retailOrderNumber={order.details.roNumber}
					fileName={"Cabinet Installer Change Order"}
					fileAttachment={order.details.files}
					submitCallback={() => refetchOrder(RefetchScope.Files)} />}
		</>
	);
}
